import React from "react";
import ClientSupport from "./ClientSupport";
import "./ContactUs.css";
import { motion } from "framer-motion";

const ContactUs = () => {
  return (
    <div className="contact-page-container">
      <div className="contact-bg-dots"></div>
      <div className="contact-page-wrapper">
        <motion.h1 
          className="contact-page-title"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-gradient-pink">CONT</span>ACT <span className="text-gradient-blue">US</span>
        </motion.h1>
        
        <motion.div 
          className="contact-heartbeat-line"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="line-left"></div>
          <svg className="heartbeat-svg" width="60" height="20" viewBox="0 0 60 20" fill="none" stroke="url(#heartbeat-gradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <defs>
              <linearGradient id="heartbeat-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#ec4899" />
                <stop offset="100%" stopColor="#3b82f6" />
              </linearGradient>
            </defs>
            <polyline points="0,10 15,10 20,2 25,18 30,10 40,10 45,5 50,15 55,10 60,10" />
          </svg>
          <div className="line-right"></div>
        </motion.div>

        <motion.div 
          className="page-content page-contact"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <ClientSupport />
        </motion.div>
      </div>
    </div>
  );
};

export default ContactUs;
